import { render, staticRenderFns } from "./CookieTable.vue?vue&type=template&id=84775126&"
import script from "./CookieTable.vue?vue&type=script&lang=js&"
export * from "./CookieTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports